<template>
  <div class="widget-wrapper">
    <widget-layout />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from './store';
import WidgetLayout from './components/WidgetLayout.vue';
import i18nProvider from './translate/i18nProvider';

const i18n = i18nProvider;

export default {
  name: 'PosWidget',
  store,
  i18n,
  props: {
    accessToken: {
      type: String,
      required: true,
    },
    applicationName: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: false,
      default: 'en',
    },
  },
  methods: {
    ...mapActions({
      setConfig: 'setConfig',
    }),
  },
  created() {
    this.setConfig({
      accessToken: this.accessToken,
      applicationName: this.applicationName,
      locale: this.locale,
    });
  },
  components: {
    WidgetLayout,
  },
};
</script>
